
import React from 'react'
import classNames from 'classnames'

class Select extends React.Component {

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    if (this.props.onChange) {
      const {input} = this.props
      let value = event.target.value
      if (value.indexOf('-') !== -1) { // if range
        let values = value.split('-')
        value = {
          min: values[0],
          max: values[1]
        }
      }
      this.props.onChange({
        valueFor: input.valueFor,
        value: value
      })
    }
  }

  render() {
    const {input, value} = this.props

    let current_value = value
    // if range
    if (current_value.min !== undefined && current_value.max !== undefined) {
      // join the values
      current_value = current_value.min + '-' + current_value.max
    }

    return (
      <select
        className={classNames('filter-select', `filter-select-${input.valueFor}` )}
        onChange={this.handleChange}
        value={current_value}
      >
      {input.options.map(function(option, index) {
        return (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        );
      })}
      </select>
    )
  }
}

Select.defaultProps = {
  input: null
}

// Select.propTypes = {
//   input: React.PropTypes.string,
//   options: React.PropTypes.shape({
//
//   })
// }

export default Select
